import script from "./UserListView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserListView.vue?vue&type=script&setup=true&lang=js"

import "./UserListView.vue?vue&type=style&index=0&id=066bf71f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066bf71f"]])

export default __exports__